import { render, staticRenderFns } from "./Impairment.vue?vue&type=template&id=cfb7971a&scoped=true"
import script from "./Impairment.vue?vue&type=script&lang=js"
export * from "./Impairment.vue?vue&type=script&lang=js"
import style0 from "./Impairment.vue?vue&type=style&index=0&id=cfb7971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb7971a",
  null
  
)

export default component.exports